import * as RadixCollapsible from '@radix-ui/react-collapsible';
import type { PropsWithChildren, JSX } from 'react';
import { useState } from 'react';

export type CollapsibleProps = {
  trigger: ({ isOpen }: { isOpen: boolean }) => JSX.Element;
  triggerPosition?: 'above' | 'below';
};

export const Collapsible = ({ children, trigger: Trigger, triggerPosition = 'above' }: PropsWithChildren<CollapsibleProps>) => {
  const [open, setOpen] = useState(false);
  return (
    <RadixCollapsible.Root open={open} onOpenChange={setOpen}>
      {triggerPosition === 'above' ? (
        <RadixCollapsible.Trigger>
          <Trigger isOpen={open} />
        </RadixCollapsible.Trigger>
      ) : null}

      <RadixCollapsible.Content>
        {children}
      </RadixCollapsible.Content>

      {triggerPosition === 'below' ? (
        <RadixCollapsible.Trigger>
          <Trigger isOpen={open} />
        </RadixCollapsible.Trigger>
      ) : null}
    </RadixCollapsible.Root>
  );
};
